<app-nav></app-nav>

<div
  class="page-body-config"
  role="main"
>
  <header>
    <h1 class="page-header">Packages</h1>
  </header>
  <div class="landing-banner">
    <img src="../../../assets/images/package_banner.png" alt="Shop Packages">
    <!-- <header class="title-bar">
      <h1 class="landing-page-title">Packages</h1>
    </header> -->
  </div>
  <div class="body-container mx-auto">
    <app-package-list
      *ngIf="step === 0"
      [orderRequest$]="packageService.orderRequest$"
      [packageList$]="packageService.packageList$"
      [activeAddress]="activeAddress"
      (orderRequestChange)="handleOrderRequestChange($event)"
      (changeStep)="handlePageContent($event)"
    ></app-package-list>
    <app-package-change-location
      *ngIf="step === 1"
      (locationChange)="handleLocationChange($event)"
      (onStartingLocationChange)="startingLocation = $event"
      (changeStep)="handlePageContent($event)"
    ></app-package-change-location>
    <app-package-search-location
      *ngIf="step === 2"
      (changeStep)="handlePageContent($event)"
    ></app-package-search-location>
    <app-package-order-summary
      *ngIf="step === 3"
      [orderRequest$]="packageService.orderRequest$"
      (orderRequestChange)="handleOrderRequestChange($event)"
      (changeStep)="handlePageContent($event)"
    ></app-package-order-summary>
    <app-package-checkout
      *ngIf="step === 4"
      [orderRequest$]="packageService.orderRequest$"
      [selectedPaymentCreditCard]="selectedPaymentCreditCard"
      [purchaseInfo$]="purchaseInfo$"
      (purchaseInfoChange)="handlePurchaseInfoChange($event)"
      (makePurchase)="handleMakePurchase($event)"
      (changeStep)="handlePageContent($event)"
    ></app-package-checkout>
    <app-package-confirm
      *ngIf="step === 5"
      [completedOrderId]="completedOrderId"
      (changeStep)="handlePageContent($event)"
    ></app-package-confirm>
    <app-package-payment-selection
      *ngIf="step === 6"
      [primaryPaymentCreditCard$]="primaryPaymentCreditCard$"
      [otherPaymentCreditCardList$]="otherPaymentCreditCardList$"
      [selectedPaymentCreditCard]="selectedPaymentCreditCard"
      (selectionChange)="handleSelectPaymentCreditCard($event)"
      (changeStep)="handlePageContent($event)"
    ></app-package-payment-selection>
  </div>
</div>
<app-footer></app-footer>
